import { useEffect, useMemo, useState } from "react";
import { toast } from "sonner";

const KEY = "atelier.cart.v1";
const fields = ["_uid", "id", "category", "series", "model_no", "door_type", "material", "finish", "color", "panel_style", "hardware_collection", "hardware_finish", "glass", "width", "height", "quantity", "notes", "image", "catalog_image", "reference_photo_id", "reference_photo_name"];
function serializableItem(item) {
  const result = Object.fromEntries(fields.filter((key) => item[key] !== undefined).map((key) => [key, item[key]]));
  if (result.image?.startsWith("blob:")) result.image = result.catalog_image || "";
  return result;
}
function loadCart() {
  try {
    const stored = JSON.parse(localStorage.getItem(KEY) || "[]");
    return Array.isArray(stored) ? stored.filter((item) => item && typeof item === "object").map((item) => ({ ...serializableItem(item), _uid: item._uid || crypto.randomUUID() })) : [];
  } catch (error) { console.warn("Cart restore failed; starting an empty cart", error.name); return []; }
}
export function useCart() {
  const [cart, setCart] = useState(loadCart);
  useEffect(() => {
    try { localStorage.setItem(KEY, JSON.stringify(cart.map(serializableItem))); }
    catch (error) { console.warn("Cart could not be saved on this device", error.name); }
  }, [cart]);
  const actions = useMemo(() => ({
    addToCart: (item) => {
      setCart((previous) => [...previous, { ...item, _uid: crypto.randomUUID() }]);
      toast.success("Added to cart", { id: "cart-added", style: { pointerEvents: "none" } });
    },
    removeFromCart: (uid) => setCart((previous) => previous.filter((item) => item._uid !== uid)),
    updateQuantity: (uid, qty) => setCart((previous) => previous.map((item) => item._uid === uid ? { ...item, quantity: Math.max(1, Number(qty) || 1) } : item)),
    updateItem: (uid, patch) => setCart((previous) => previous.map((item) => item._uid === uid ? { ...item, ...patch, _uid: item._uid } : item)),
    clearCart: () => setCart([]),
  }), []);
  return { cart, actions };
}